import { ILogger, ILoggerFactory, LogMessageMetadata } from './types.js';

export { LoggerContext } from './context.js';
export { LoggerFactory } from './factory.js';
export { ILogger, LogLevel, LogLevelString, LogLevelStringValues, parseLogLevel, parseLogLevelSafe } from './types.js';
export { hijackConsole } from './utils.js';

declare global {
  // eslint-disable-next-line no-var
  var loggerFactory: null | ILoggerFactory;

  interface Window {
    loggerFactory: null | ILoggerFactory;
  }
}

const globalObject = typeof global !== 'undefined' ? global : window;

globalObject.loggerFactory = null;
export function setLoggerFactory(factory: ILoggerFactory) {
  globalObject.loggerFactory = factory;
}
export function createLogger(id: string, metadata?: LogMessageMetadata): ILogger {
  if (globalObject.loggerFactory == null) {
    throw new Error('The logger framework must be configured via setLoggerFactory');
  }
  return globalObject.loggerFactory.createLogger(id, metadata, null);
}
